export type Size = number | string;

export const autoUnitSize = (value: Size) => {
  return typeof value === "number" ? `${value / 16}rem` : value;
};
